import Nav from '../../Global/Nav.vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

var _EditorOption_ = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline'], // 加粗 斜体 下划线 删除线
      [{ size: [12, 14, 16] }], // 字体大小
      [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
      [{ align: [] }], // 对齐方式
      ['clean'], // 清除文本格式
      ['link', 'image', 'video'] // 链接、图片、视频
      // ['link'] // 链接、图片、视频
    ]
  },
  placeholder: '请输入正文'
};
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
];

export default {
  name: 'ALCMailer',
  components: {
    Nav,
    quillEditor
  },
  data() {
    return {
      uploadApi: this.$axios.defaults.baseURL + 'files/upload',
      headersObj: {
        'x-authorization-token': this.$userinfo.api_token
      },
      activeTab: 'accounts',
      composeTitle: '写邮件',
      emailAccountsOptions: [],
      emailAccountsCurrentSelected: '',
      emailAccountsVisible: false,
      emailAccountsData: [],
      emailAccountsTotal: 0,
      emailAccountsSize: 10,
      emailAccountsCurrentPage: 1,
      addEmailAccountVisible: false,
      addEmailAccountLoading: false,
      addEmailAccountForm: {
        username: '',
        password: '',
        sync: false
      },
      addEmailAccountRules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' }
        ]
      },
      accountId: 0,
      folderList: [],
      folderDefaultActive: '1-1',
      mailDefaultActive: '2-1',
      mailsList: [],
      email: {},
      editorOption: _EditorOption_,
      composeForm: {
        message_id: '',
        composeEmailAccount: '',
        receiver: '',
        cc: '',
        subject: '',
        attachmentsList: [],
        content: ''
      },
      composeAttachments: false,
      composeLoading: false,
      composeTemplates: false,
      folder_list_loading: false,
      mail_list_loading: false,
      email_main_content_loading: false,
      folder_index: 0,
      mail_list_index: 0,
      editEmailAccountVisible: false,
      editEmailAccountLoading: false,
      editEmailAccountForm: {
        id: null,
        username: null,
        password: null,
        sync: false
      },
      editEmailAccountRules: {
      }
    }
  },
  mounted() {
    this.getEmailAccountsOptions();
    // this.intervals = setInterval(() => {
    //   if (this.activeTab === 'accounts') {
    //     this.getEmailAccountsFolderInfo(this.emailAccountsCurrentSelected, true);
    //   }
    // }, 60000);
  },
  methods: {
    tabClick(tab, event) {
      switch (tab.name) {
        case 'emailList':
          this.getEmailAccountsOptions();
          break;
      }
    },
    refresh() {
      this.getEmailAccountsFolderInfo(this.emailAccountsCurrentSelected);
    },
    setFolderIndex(index) {
      this.folder_index = index;
    },
    setMailListIndex(index) {
      this.mail_list_index = index;
    },
    setEmailAccounts(event) {
      this.folder_index = 0;
      this.mail_list_index = 0;
      this.getEmailAccountsFolderInfo(event);
    },
    async getEmailAccountsOptions(emailAccountsCurrentSelected = 0) {
      await this.$axios.get(`mailer/accounts/options`).then((response) => {
        if (response.data.code === 200 && response.data.data.length > 0) {
          let data = response.data.data;
          let emailAccountsCurrentSelected = data[0].value;
          this.emailAccountsOptions = data
          this.emailAccountsCurrentSelected = emailAccountsCurrentSelected;
          this.getEmailAccountsFolderInfo(emailAccountsCurrentSelected);
        }
      });
    },
    async getEmailAccountsFolderInfo(id, sync = false) {
      this.folder_list_loading = true
      if (id && id !== '') {
        this.accountId = id
        this.composeForm.composeEmailAccount = id
        await this.$axios.get(`mailer/folders?id=` + id).then((response) => {
          this.folderList = response.data.data
          this.folder_list_loading = false
          setTimeout(() => {
            if (this.folderList.length > 0) {
              this.queryFolderEmails(this.folderList[this.folder_index], sync)
            } else {
              this.mailsList = [];
              this.email = {};
            }
          })
        })
      }
    },
    getAccountsList() {
      this.$axios.get(`mailer/accounts/list`, {
        params: {
          size: this.emailAccountsSize,
          page: this.emailAccountsCurrentPage
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.emailAccountsData = response.data.data.data
          this.emailAccountsTotal = response.data.data.total
        }
      });
    },
    changeEmailAccountsSize(val) {
      this.emailAccountsSize = val;
      this.getAccountsList();
    },
    CurrentEmailAccountsChange(val) {
      this.emailAccountsCurrentPage = val;
      this.getAccountsList();
    },
    emailAccountsToggleStatus(row) {
      this.$axios.post('mailer/accounts/toggle_status', {
        id: row.id,
        status: row.status
      }).then((response) => {
        if (response.data.code === 200) {
          this.getEmailAccountsOptions();
        } else {
          row.status = !row.status
          this.$notify({
            title: 'failed',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    emailAccountsDel(row) {
      this.$confirm('此操作将永久删除该邮箱, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('mailer/accounts/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getAccountsList();
            setTimeout(() => {
              this.getEmailAccountsOptions();
            })
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    },
    emailAccountsEdit(row) {
      this.editEmailAccountVisible = true;
      this.editEmailAccountForm.id = row.id;
      this.editEmailAccountForm.username = row.username;
    },
    manageAccounts() {
      this.emailAccountsVisible = true;
      this.getAccountsList()
    },
    addEmailAccount() {
      this.addEmailAccountVisible = true;
    },
    cancelAddEmailAccount() {
      this.addEmailAccountVisible = false;
      this.addEmailAccountForm = {}
    },
    confirmAddEmailAccount() {
      this.$refs.addEmailAccountForm.validate(valid => {
        if (valid) {
          this.addEmailAccountLoading = true
          this.$axios.post(`/mailer/accounts/add`,
            this.addEmailAccountForm
          ).then((response) => {
            this.addEmailAccountLoading = false
            if (response.data.code === 200) {
              this.$notify({
                title: 'success',
                message: '保存成功',
                type: 'success'
              })
              this.addEmailAccountVisible = false;
              this.addEmailAccountForm = {
                username: '',
                password: ''
              }
              this.getAccountsList();
              setTimeout(() => {
                this.getEmailAccountsOptions();
              })
            } else {
              this.$notify({
                title: 'error',
                message: response.data.data,
                type: 'error'
              })
            }
          })
        }
      })
    },
    cancelEditEmailAccount() {
      this.editEmailAccountVisible = false;
      this.editEmailAccountForm = {
        id: null,
        username: null,
        password: null,
        sync: false
      }
    },
    confirmEditEmailAccount() {
      this.$refs.editEmailAccountForm.validate(valid => {
        if (valid) {
          this.editEmailAccountLoading = true
          this.$axios.post(`/mailer/accounts/save`,
            this.editEmailAccountForm
          ).then((response) => {
            this.editEmailAccountLoading = false
            if (response.data.code === 200) {
              this.$notify({
                title: 'success',
                message: '保存成功',
                type: 'success'
              })
              this.editEmailAccountVisible = false;
              this.editEmailAccountForm = {
                id: null,
                username: null,
                password: null,
                sync: false
              }
              this.getAccountsList();
              setTimeout(() => {
                this.getEmailAccountsOptions();
              })
            } else {
              this.$notify({
                title: 'error',
                message: response.data.data,
                type: 'error'
              })
            }
          })
        }
      })
    },
    async queryFolderEmails(ev, sync = false) {
      this.mail_list_loading = true;
      let accountId = this.accountId;
      let folder = ev.folder;
      this.$axios.get(`mailer/folders/detail?id=` + accountId + `&folder=` + folder).then((response) => {
        if (response.data.code === 200) {
          this.mailsList = response.data.data
          this.mail_list_loading = false;
          setTimeout(() => {
            if (this.mailsList.length > 0) {
              if (sync === false) {
                this.queryEmailDetail(this.mailsList[this.mail_list_index])
              }
            }
          })
        }
      });
    },
    queryEmailDetail(ev) {
      this.email_main_content_loading = true;
      let message_id = encodeURIComponent(ev.message_id)
      let mail_id = ev.id;
      this.$axios.get(`mailer/email/detail?id=` + mail_id + `&seen=1`).then((response) => {
        if (response.data.code === 200) {
          this.email_main_content_loading = false;
          this.email = response.data.data
        }
      });
    },
    downloadAttachment(ev) {
      window.location.href = this.$axios.defaults.baseURL + 'mailer/email/attachment_download?id=' + ev.id;
    },
    composeAttachmentsSuccess(response) {
      if (response.code === 200) {
        this.composeForm.attachmentsList.push(response.data)
      } else {
        this.$notify({
          title: 'failed',
          message: response.data,
          type: 'warning'
        })
      }
    },
    composeSend() {
      if (this.composeForm.receiver === '' || this.composeForm.subject === '') {
        this.$notify({
          title: 'Error',
          message: '收件人和主题不能为空',
          type: 'error'
        })
      }
      this.composeLoading = true
      this.$axios.post(`mailer/email/send`, this.composeForm).then((response) => {
        this.composeLoading = false
        if (response.data.code === 200) {
          this.$notify({
            title: 'Success',
            message: 'Email sent success',
            type: 'success'
          })
          let composeEmailAccount = this.composeForm.composeEmailAccount
          setTimeout(() => {
            this.composeForm = {
              composeEmailAccount: composeEmailAccount,
              receiver: '',
              cc: '',
              subject: '',
              attachmentsList: [],
              content: ''
            }
            this.composeTitle = '写邮件'
          })
        } else {
          this.$notify({
            title: 'Error',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    composeDraft() {
      this.$axios.post(`mailer/email/draft`, this.composeForm).then((response) => {
        if (response.data.code === 200) {
          this.$notify({
            title: 'Success',
            message: 'Draft saved success',
            type: 'success'
          })
        } else {
          this.$notify({
            title: 'Error',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    composeTo(to) {
      this.activeTab = 'compose';
      this.composeForm.receiver = to;
    },
    forward() {
      this.activeTab = 'compose';
      this.composeTitle = 'Fw';
      this.composeForm.subject = 'Fw: ' + this.email.subject
      this.composeForm.message_id = this.email.message_id
      this.composeForm.attachmentsList = []
      let html = `  
      <br><br>------------------------------------------------------------------<br>  
        <div>  
          <p><b>发件人:</b> ${this.email.from_name ? this.email.from_name : ''}</p>  
          <p><b>发送时间:</b> ${this.email.date}</p>  
          <p><b>收件人:</b> ${this.email.to_string}</p>  
          ${this.email.cc_string ? `<p><b>抄送:</b> ${this.email.cc_string}</p>` : ''}  
          <p><b>主题:</b> ${this.email.subject}</p>  
        </div>  
        <br><br>  
      `;
      this.composeForm.content = html + (this.email.text_html !== '' ? this.email.text_html : this.email.text_plain)
    },
    reply() {
      this.activeTab = 'compose';
      this.composeTitle = 'Re';
      this.composeForm.receiver = this.email.from_address
      this.composeForm.subject = 'Re: ' + this.email.subject
      this.composeForm.message_id = this.email.message_id
      this.composeForm.attachmentsList = []
      let html = `  
      <br><br>------------------------------------------------------------------<br>  
        <div>
          <p><b>发件人:</b> ${this.email.from_name ? this.email.from_name : ''}</p>  
          <p><b>发送时间:</b> ${this.email.date}</p>  
          <p><b>收件人:</b> ${this.email.to_string}</p>  
          ${this.email.cc_string ? `<p><b>抄送:</b> ${this.email.cc_string}</p>` : ''}  
          <p><b>主题:</b> ${this.email.subject}</p>  
        </div>  
        <br><br>  
      `;
      // if(this.email.text_html != ''){
      //   this.composeForm.content = this.email.text_html.replace('<body>', `<body>${html}`);
      // }else{
      //   this.composeForm.content = html + this.email.text_plain
      // }
      // let modifiedHtml = existingHtml.replace('<body>', `<body>${html}`);
      this.composeForm.content = html + (this.email.text_html !== '' ? this.email.text_html : this.email.text_plain)
    },
    composeGiveup() {
      this.$confirm('此操作不可恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.activeTab = 'compose';
        this.composeTitle = '写邮件';
        this.composeForm = {
          message_id: '',
          composeEmailAccount: '',
          receiver: '',
          cc: '',
          subject: '',
          attachmentsList: [],
          content: ''
        }
      })
    },
    showTemplates() {
      this.composeTemplates = true
    },
    beforeDestroy() {
      clearInterval(this.intervals);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/ALCMailer/script.js